import {
  GET_PLC_POPUP_STATUS,
  GET_PLC_POPUP_STATUS_SUCCESS,
  GET_PLC_POPUP_STATUS_ERROR,
} from "./actionTypes";

export const getPlcPopupStatus = (token) => {
  return {
    type: GET_PLC_POPUP_STATUS,
    payload: { token },
  };
};

export const getPlcPopupStatusSuccess = (message, plc_popup_status) => {
  return {
    type: GET_PLC_POPUP_STATUS_SUCCESS,
    payload: { message, plc_popup_status },
  };
};

export const getPlcPopupStatusError = (message) => {
  return {
    type: GET_PLC_POPUP_STATUS_ERROR,
    payload: message,
  };
};
